<app-auth-shell title="Criar conta" subtitle="Uma conta para todo o ecossistema">
  <form class="auth-login__form" role="form" [formGroup]="formSignup" (ngSubmit)="signup()">
    <div class="auth-field">
      <label class="auth-field__label" for="email">E-mail</label>
      <div class="auth-field__control">
        <input id="email" type="email" formControlName="email" class="auth-field__input" placeholder="nome@empresa.com" autocomplete="email" appFocus />
      </div>
      @if (formSignup.get('email')?.dirty) { @if (formSignup.get('email')?.hasError('required')) {
      <div class="auth-field__error">Campo obrigatório</div>
      } @if (formSignup.get('email')?.hasError('email')) {
      <div class="auth-field__error">E-mail inválido</div>
      } }
    </div>
    <div class="auth-field">
      <label class="auth-field__label" for="password">Senha</label>
      <div class="auth-field__control">
        <input
          id="password"
          type="password"
          formControlName="password"
          class="auth-field__input auth-field__input--toggle"
          placeholder="Crie uma senha"
          autocomplete="new-password"
          maxlength="60"
          aria-describedby="password-rules"
        />
        <button type="button" class="auth-field__toggle" appShow aria-label="Mostrar senha">
          <span><i class="fas fa-eye"></i></span>
        </button>
      </div>
      <app-password-checklist [password]="formSignup.get('password')?.value" />
    </div>
    <div class="auth-field">
      <label class="auth-field__label" for="confirmPassword">Confirmar senha</label>
      <div class="auth-field__control">
        <input
          id="confirmPassword"
          type="password"
          formControlName="confirmPassword"
          class="auth-field__input auth-field__input--toggle"
          placeholder="Repita a senha"
          autocomplete="new-password"
        />
        <button type="button" class="auth-field__toggle" appShow aria-label="Mostrar senha">
          <span><i class="fas fa-eye"></i></span>
        </button>
      </div>
      @if (formSignup.get('confirmPassword')?.dirty) { @if (formSignup.get('confirmPassword')?.hasError('required')) {
      <div class="auth-field__error">Campo obrigatório</div>
      } @if (formSignup.get('confirmPassword')?.hasError('compare')) {
      <div class="auth-field__error">As senhas não conferem</div>
      } }
    </div>
    <label class="auth-check" for="termos">
      <input class="auth-check__input" type="checkbox" id="termos" (click)="checkTermos()" />
      <span>
        Li e concordo com os
        <a class="auth-link" [routerLink]="['/termos']" (click)="$event.stopPropagation()">Termos de Uso</a>
        e a
        <a class="auth-link" [routerLink]="['/privacidade']" (click)="$event.stopPropagation()">Política de Privacidade</a>
      </span>
    </label>
    <button type="submit" class="auth-btn" [disabled]="!formSignup.valid || !termos">Criar conta</button>
  </form>
  <div class="auth-login__divider"><span>ou cadastre-se com</span></div>
  <div class="auth-login__social">
    <div class="social-login-btn">
      <button type="button" class="auth-social__btn social-login-btn__visible" tabindex="-1" aria-hidden="true">
        <i class="fab fa-google auth-social__google"></i>
        Google
      </button>
      <div id="google-btn-container-signup" class="social-login-btn__overlay" aria-label="Cadastrar com Google"></div>
    </div>
    <button type="button" class="auth-social__btn" (click)="loginWithFacebook()">
      <i class="fab fa-facebook-f auth-social__facebook"></i>
      Facebook
    </button>
  </div>
  <p class="auth-login__signup" authShellFooter>Já tem uma conta? <a [routerLink]="['/signin']">Entrar</a></p>
</app-auth-shell>
